import { useTranslation } from "react-i18next";
import { Modal } from "../../common";
import { Button } from "../../App.styles";

const DescriptionModal = ({ onDismiss, show }) => {
    const { t } = useTranslation();

    return (
        <Modal onDismiss={onDismiss} show={show}>
            <div className="modal-header">
                <h4 className="modal-title" dangerouslySetInnerHTML={{ __html: t(`NPC Description`) }} />
                <button
                    type="button"
                    className="close"
                    data-dismiss="modal"
                    aria-hidden="true"
                    onClick={onDismiss}
                >
                    ×
                </button>
            </div>
            <div className="modal-body">
                <p dangerouslySetInnerHTML={{
                    __html: t(`The description is where you instruct the AI as to who it is. Modify the default description to personalize your NPC.`)
                }} />
                <ul>
                    <li dangerouslySetInnerHTML={{
                        __html: t(`You can use up to 2 pages of text in your description.`)
                    }} />
                    <li dangerouslySetInnerHTML={{
                        __html: t(`Give your NPC unique information to enable fun game mechanics as players interact with the NPC`)
                    }} />
                    <li dangerouslySetInnerHTML={{
                        __html: t(`Tell your NPC about their character background, tone of voice etc.`)
                    }} />
                </ul>
            </div>
            <div className="modal-footer">
                <Button type="button" color="dark" data-dismiss="modal" onClick={onDismiss}>
                    {t(`Close`)}
                </Button>
            </div>
        </Modal>
    )
};

export default DescriptionModal;
